import { useProxyModelValue as K, useResponsive as Q } from "@onereach/ui-components-common/hooks";
import { O as U } from "./OrButton-C_hXddAf.mjs";
import { O as W } from "./OrIcon-k8cyvh-D.mjs";
import { O as X } from "./OrMenuItem-BHRMA0L1.mjs";
import { O as Y } from "./OrMenu-CJT4Snay.mjs";
import { defineComponent as Z, ref as O, computed as n, toRef as _, resolveComponent as B, openBlock as a, createElementBlock as p, normalizeClass as f, createElementVNode as D, createTextVNode as v, createVNode as s, withCtx as u, toDisplayString as m, Fragment as h, renderList as G, createBlock as L, createCommentVNode as S } from "vue";
import { _ as x } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const ee = [
  // Layout
  "layout-row justify-between md:justify-end",
  // Spacing
  "gap-xl",
  // Typography
  "typography-caption-regular",
  // Theme
  "theme-foreground-outline",
  "dark:theme-foreground-outline-dark"
], te = [
  // Layout
  "layout-row shrink-0",
  // Spacing
  "gap-lg md:gap-md"
], oe = [
  // Layout
  "layout-row shrink-0",
  // Spacing
  "gap-md"
], ne = [
  // Typography
  "typography-caption-regular",
  // Typography (activated)
  "activated:typography-caption-bold"
], re = Z({
  name: "OrPagination",
  components: {
    OrButton: U,
    OrIcon: W,
    OrMenu: Y,
    OrMenuItem: X
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: void 0,
      default: void 0
    },
    length: {
      type: Number,
      required: !0
    },
    options: {
      type: Array,
      default: () => [50, 20, 10, 5]
    },
    features: {
      type: Object,
      default: () => ({
        limit: !0,
        range: !0
      })
    }
  },
  emits: [
    "update:modelValue"
  ],
  expose: [
    "root",
    "currentLimit"
  ],
  setup(e, i) {
    const R = O(), I = n(() => [
      "or-pagination-v3",
      ...ee
    ]), $ = O(), N = n(() => {
      var t;
      return (t = $.value) == null ? void 0 : t.root;
    }), d = O(), c = n(() => {
      var t;
      return (t = d.value) == null ? void 0 : t.root;
    }), w = n(() => [
      ...te
    ]), k = O(), o = n(() => {
      var t;
      return (t = k.value) == null ? void 0 : t.root;
    }), g = O(), j = n(() => {
      var t;
      return (t = g.value) == null ? void 0 : t.root;
    }), A = n(() => [
      ...oe
    ]), E = n(() => [
      ...ne
    ]), M = K(_(e, "modelValue"), i.emit), P = n({
      get: () => {
        var t;
        return ((t = M.value) == null ? void 0 : t.limit) ?? e.options[0];
      },
      set: (t) => {
        M.value = {
          limit: t,
          offset: 0
        };
      }
    }), V = n({
      get: () => {
        var t;
        return ((t = M.value) == null ? void 0 : t.offset) ?? 0;
      },
      set: (t) => {
        M.value = {
          limit: P.value,
          offset: t
        };
      }
    }), l = n({
      get: () => Math.floor(V.value / P.value) + 1,
      set: (t) => {
        V.value = (t - 1) * P.value;
      }
    }), b = n(() => 1), y = n(() => Math.ceil(e.length / P.value)), q = n(() => {
      const t = Array.from({ length: y.value }, (r, C) => C + 1);
      switch (!0) {
        case y.value <= 7:
          return t;
        case l.value < b.value + 4:
          return [
            ...t.slice(0, 5),
            "…",
            y.value
          ];
        case l.value > y.value - 4:
          return [
            b.value,
            "…",
            ...t.slice(-5)
          ];
        default:
          return t.map((r) => {
            switch (!0) {
              case (r > b.value && r < l.value - 1):
              case (r < y.value && r > l.value + 1):
                return "…";
              default:
                return r;
            }
          }).reduce((r, C) => r[r.length - 1] === C ? r : [...r, C], []);
      }
    });
    function z() {
      l.value = l.value - 1;
    }
    function F() {
      l.value = l.value + 1;
    }
    function T(t) {
      l.value = t;
    }
    const { isDesktop: H, isMobile: J } = Q();
    return {
      root: R,
      rootStyles: I,
      limitButton: $,
      limitButtonRoot: N,
      limitMenu: d,
      limitMenuRoot: c,
      limitGroupStyles: w,
      offsetButton: k,
      offsetButtonRoot: o,
      offsetMenu: g,
      offsetMenuRoot: j,
      offsetGroupStyles: A,
      itemStyles: E,
      model: M,
      currentLimit: P,
      currentOffset: V,
      currentPage: l,
      firstPage: b,
      lastPage: y,
      buttonGroup: q,
      toPreviousPage: z,
      toNextPage: F,
      toPage: T,
      isDesktop: H,
      isMobile: J
    };
  }
}), ie = {
  key: 0,
  class: /* @__PURE__ */ f(["layout-row", "gap-sm"])
};
function le(e, i, R, I, $, N) {
  const d = B("OrIcon"), c = B("OrButton"), w = B("OrMenuItem"), k = B("OrMenu");
  return a(), p("div", {
    ref: "root",
    class: f(e.rootStyles)
  }, [
    D("div", {
      class: f(e.limitGroupStyles)
    }, [
      e.features.limit ? (a(), p("div", ie, [
        v(" Per page: "),
        s(c, {
          ref: "limitButton",
          class: f(e.itemStyles),
          variant: "link",
          color: "inherit",
          activated: !0,
          onClick: i[0] || (i[0] = (o) => e.limitMenu && e.limitMenu.toggle())
        }, {
          default: u(() => [
            v(m(e.currentLimit) + " ", 1),
            s(d, {
              icon: e.limitMenu && e.limitMenu.state === "open" ? "arrow_drop_up" : "arrow_drop_down"
            }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["class"]),
        s(k, {
          ref: "limitMenu",
          "additional-styles": ["min-w-[60px]"],
          trigger: e.limitButtonRoot,
          placement: "top"
        }, {
          default: u(() => [
            (a(!0), p(h, null, G(e.options, (o) => (a(), L(w, {
              key: o,
              selected: e.currentLimit === o,
              onClick: (g) => {
                e.currentLimit = o, e.limitMenu && e.limitMenu.close();
              }
            }, {
              default: u(() => [
                v(m(o), 1)
              ]),
              _: 2
            }, 1032, ["selected", "onClick"]))), 128))
          ]),
          _: 1
        }, 8, ["trigger"])
      ])) : S("", !0),
      e.features.range ? (a(), p(h, { key: 1 }, [
        v(m(e.currentOffset + 1) + "-" + m(Math.min(e.currentOffset + e.currentLimit, e.length)) + " of " + m(e.length), 1)
      ], 64)) : S("", !0)
    ], 2),
    D("div", {
      class: f(e.offsetGroupStyles)
    }, [
      s(c, {
        class: f(e.itemStyles),
        variant: "link",
        color: "inherit",
        disabled: e.currentPage === e.firstPage,
        onClick: i[1] || (i[1] = (o) => e.toPreviousPage())
      }, {
        default: u(() => [
          s(d, { icon: "keyboard_arrow_left" })
        ]),
        _: 1
      }, 8, ["class", "disabled"]),
      e.isDesktop ? (a(!0), p(h, { key: 0 }, G(e.buttonGroup, (o, g) => (a(), L(c, {
        key: g,
        class: f(e.itemStyles),
        variant: "link",
        color: "inherit",
        activated: e.currentPage === o,
        onClick: (j) => typeof o == "number" && e.toPage(o)
      }, {
        default: u(() => [
          v(m(o), 1)
        ]),
        _: 2
      }, 1032, ["class", "activated", "onClick"]))), 128)) : S("", !0),
      e.isMobile ? (a(), p(h, { key: 1 }, [
        s(c, {
          ref: "offsetButton",
          class: f(e.itemStyles),
          variant: "link",
          color: "inherit",
          activated: !0,
          onClick: i[2] || (i[2] = (o) => e.offsetMenu && e.offsetMenu.open())
        }, {
          default: u(() => [
            v(m(e.currentPage) + " ", 1),
            s(d, {
              icon: e.offsetMenu && e.offsetMenu.state === "open" ? "arrow_drop_up" : "arrow_drop_down"
            }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["class"]),
        s(k, {
          ref: "offsetMenu",
          "additional-styles": ["min-w-[60px]"],
          trigger: e.offsetButtonRoot,
          placement: "top"
        }, {
          default: u(() => [
            (a(!0), p(h, null, G(e.lastPage, (o) => (a(), L(w, {
              key: o,
              selected: e.currentPage === o,
              onClick: (g) => {
                e.currentPage = o, e.offsetMenu && e.offsetMenu.close();
              }
            }, {
              default: u(() => [
                v(m(o), 1)
              ]),
              _: 2
            }, 1032, ["selected", "onClick"]))), 128))
          ]),
          _: 1
        }, 8, ["trigger"])
      ], 64)) : S("", !0),
      s(c, {
        class: f(e.itemStyles),
        variant: "link",
        color: "inherit",
        disabled: e.currentPage === e.lastPage,
        onClick: i[3] || (i[3] = (o) => e.toNextPage())
      }, {
        default: u(() => [
          s(d, { icon: "keyboard_arrow_right" })
        ]),
        _: 1
      }, 8, ["class", "disabled"])
    ], 2)
  ], 2);
}
const pe = /* @__PURE__ */ x(re, [["render", le]]);
export {
  pe as O
};
//# sourceMappingURL=OrPagination-BFUGGyGy.mjs.map
